export default class ClubRoleRight {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubRoleRight = new ClubRoleRight();
        clubRoleRight.right = data.right;
        clubRoleRight.scope = data.scope;
        clubRoleRight.status = data.status;

        Object.seal(clubRoleRight);
        return clubRoleRight;
    }
}
